import React, { useEffect, useState } from 'react'
import Page from '../../../layouts/Page'

import { DESENDING_ORDER, LISTING_LIMIT, ORDER_DESCENDING } from '../../../constants'
import useApi from "../../../hooks/useApi";
import axios from 'axios';
import { customStringify } from '../../../utils';
import { network_tl } from '../../../translations';
import { FormattedMessage, useIntl } from 'react-intl';
import Loading from '../../../components/Loading'
import RetryApi from '../../../components/RetryApi';
import Pagination from '../../../components/Pagination';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Filters from '../../Requests/Filters';
import Card from '../../Requests/Card';



const Requests = ({ id }) => {
    const intl = useIntl();
    const { Axios } = useApi();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [count, setCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
    const [refresh, setRefresh] = useState(false);

    let offset = 0;

    const [filters, setFilters] = useState({
        search: "",
        status: "",
        content: "",
        sort_order: ORDER_DESCENDING
    })

    const [appliedFilters, setAppliedFilters] = useState({
        search: "",
        status: "",
        sort_order: ORDER_DESCENDING
    })



    const getData = async (curr) => {
        try {
            setLoading(true);
            setError(false);
            if (curr) {
                offset = 0;
            }
            else if (count) {
                offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
            } else {
                offset = 0;
            }
            const result = await Axios.get(`api/influencer/invited/influencer/${id}?limit=${LISTING_LIMIT}&offset=${offset}&search=${appliedFilters.search.trim()}&status=${appliedFilters.status ? appliedFilters.status.value : ""}&content_type=${appliedFilters.content ? appliedFilters.content.value : ""}&sort_order=${appliedFilters.sort_order}`);
            setData(result.data.payload);
            setLoading(false);
            setCount(result.data.count)
        } catch (e) {
            if (axios.isCancel(e)) {

            } else if (e.response) {
                setError(customStringify(e.response.data.description))
                setLoading(false)
            } else {
                setError(network_tl(intl))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        getData()
    }, [currentPage, sort, refresh])

    useEffect(() => {
        getData(1)
    }, [appliedFilters])

    const applyFilters = () => {
        const copy = _.cloneDeep(filters)
        setCurrentPage(1);
        setAppliedFilters(copy)
    }

    const resetFilters = () => {
        setCurrentPage(1)
        setFilters({
            search: "",
            status: "",
            content: "",

            sort_order: ORDER_DESCENDING
        })
        setAppliedFilters({
            search: "",
            status: "",
            content: "",

            sort_order: ORDER_DESCENDING
        })
    }

    const refreshListing = () => {
        setCurrentPage(1);
        getData(1)
    }


    return (
        <>

            <div className=' container'>
                <div className='pt-5 pb-10'>
                    <Filters
                        filters={filters}
                        setFilters={setFilters}
                        applyFilters={applyFilters}
                        resetFilters={resetFilters}
                        appliedFilters={appliedFilters}
                    />
                </div>
                {
                    loading && !error ?
                        <Loading />
                        :
                        error && !loading ?
                            <RetryApi retry={getData} error={error} />
                            :
                            <><div>
                                {data.length > 0 ?
                                    <div className='grid grid-cols-1 md:grid-cols-2  xl:grid-cols-3 gap-5'>
                                        {data.map((item) => (
                                            <>
                                                <Card item={item.deliverable} fromAgency={id} data={item} refreshListing={refreshListing} />
                                            </>
                                        ))}
                                    </div>
                                    :
                                    <p className='text-center text-t-light test-sm'><FormattedMessage id="no_requests_available" defaultMessage={"No Requests Available"} /></p>}
                            </div><div className="container flex my-10 justify-end">
                                    <Pagination
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        perPage={LISTING_LIMIT}
                                        offset={offset}
                                        total_pages={Math.ceil(count / LISTING_LIMIT)}
                                        count={count} />
                                </div></>
                }
            </div>


        </>
    )
}

export default Requests